import { render } from "./NotificationBadge.vue?vue&type=template&id=dbff40ca&scoped=true"
const script = {}

import "./NotificationBadge.vue?vue&type=style&index=0&id=dbff40ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbff40ca"]])

export default __exports__